import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { IDocMetaDomainService } from '../../doc-meta';
import { IUserInfoDomainService } from '../../user-info';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var EnterpriseLikeDomainService = /** @class */ (function () {
    function EnterpriseLikeDomainService(docMetaDomain, userInfoDomain) {
        this.docMetaDomain = docMetaDomain;
        this.userInfoDomain = userInfoDomain;
    }
    EnterpriseLikeDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('EnterpriseLikeDomainService ~ init ~ do nothing', requestParam);
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EnterpriseLikeDomainService.prototype, "init", null);
    EnterpriseLikeDomainService = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, IUserInfoDomainService),
        __metadata("design:paramtypes", [Object, Object])
    ], EnterpriseLikeDomainService);
    return EnterpriseLikeDomainService;
}());
export { EnterpriseLikeDomainService };
